import { Globals } from "@/Globals";
import router from "@/router/index";
import { begriffBezeichnung, globalsBezeichnung } from "./local";
import { getCurrentInstance } from "vue";
import { useRoute } from "vue-router";
import { getDialogSiteData, closeHighestDialog } from "./UIHelper";

let isNavigating: boolean = false;
let activeBtn: number = 0;

let rootView: NavStackEntry = {
  site: "AllWelcome",
  title: "Willkommen",
  data: null
};

export interface UIInterface {
  refreshZeitRaumInHeader: (showZeitraum: boolean) => void;
  refreshFullPageContent: () => void;
  getActiveViewIndex: () => number;
  setActiveViewIndex: (index: number) => number;
  setBottomActiveButton: (activeBtn: number) => void;
}

export interface NavStackEntry {
  site: string;
  title?: string;
  aic?: number;
  name?: string;
  data?: any;
  showZeitraum?: boolean;
  showZeitRaumInHeader?: boolean;
  callOnLeave?: (() => void) | null;
}

interface NavStackEntryRequest {
  replaceCurrent?: boolean;
  site: string;
  title?: string;
  aic?: number;
  name?: string;
  data?: any;
  showZeitraumHeader?: boolean;
  callOnLeave?: (() => void) | null;
}

let contentStack: NavStackEntry[] = [];
let UI: UIInterface;

const backCallbacks: (() => boolean)[] = [];

export function initNavigationHelper(newContentStack: NavStackEntry[], ui: UIInterface) {
  UI = ui;
  contentStack = newContentStack;
  // ausleeren und neu beginnen
  contentStack.length = 0;
  contentStack.push({
    site: "AllWelcome",
    title: globalsBezeichnung(
      Globals.Begriff,
      "Web_Willkommen",
      "Willkommen"
    )
  });

  cleanupSiteDataCache();
}

const siteDataStartupChar = '~#';
const siteDataNameLength = 6;
const daysToCacheLinks = 3;

function cleanupSiteDataCache() {
  const prefixLength = siteDataStartupChar.length + siteDataNameLength;

  const now = new Date();
  const keysToDelete = [];
  for (let i = 0; i < localStorage.length; i++) {
    const key = localStorage.key(i);
    if (!key?.startsWith(siteDataStartupChar)) continue;

    var date = new Date(parseInt(key.substring(prefixLength)));
    const duration = Math.abs(now.diffInDays(date));
    if (duration > daysToCacheLinks)
      keysToDelete.push(key);
  }

  keysToDelete.forEach(k => localStorage.removeItem(k));
}

const sitedata: { [id: string]: any } = {};

function generateSiteDataId(site: string) {
  return siteDataStartupChar + site.substring(0, siteDataNameLength) + new Date().valueOf();
}

function getShowZeitraumInHeader(entry?: NavStackEntry | null) {
  return entry?.showZeitRaumInHeader ?? entry?.showZeitraum ?? false;
}

export function setRootView(newRoot: NavStackEntry) {
  rootView = newRoot;
  if (rootView.name) {
    rootView.title = begriffBezeichnung(rootView.name);
  }
  // if (newRoot.title === "Dashboard") {
  //   UI.setBottomActiveButton(1);
  // }
  //router.push()
  // auf RootView setzen!
  pushSite(rootView.site, undefined, rootView.name, 0, getShowZeitraumInHeader(rootView));
  contentStack.length = 0;
  contentStack.push(rootView);
}


export async function pushSite(
  site: string,
  data: any,
  title: string | null = null,
  aic: any,
  showZeitRaumInHeader?: boolean,
  callOnLeave: (() => void) | null = null
) {
  if (!title) {
    title = site.replace(/^(All|Base)/, "");
  }
  try {
    console.log("showing site:" + site + " with title " + title);

    const headerVisible = showZeitRaumInHeader ?? false;
    const navOpt: NavStackEntry = {
      site,
      data,
      title,
      aic,
      showZeitraum: headerVisible,
      showZeitRaumInHeader: headerVisible,
      callOnLeave,
    };
    const navState = { site, data, title, aic };
    if (contentStack) {
      if (UI.getActiveViewIndex() === 0 && contentStack[0].site === site) {
        return;
      }
    }
    isNavigating = true;
    contentStack.push(navOpt);
    UI.setActiveViewIndex(contentStack.length - 1); // - erzeugt immer wieder einen Error...
    // UI.setBottomActiveButton(1);

    let queryId: string | undefined;
    if (data) {
      queryId = generateSiteDataId(site);
      localStorage.setItem(queryId, JSON.stringify(data));
      await router.push({
        path: site,
        query: { id: queryId }
      });
    } else {
      await router.push({
        path: site,
      });
    }
    await router.isReady()
    isNavigating = false;
    UI.refreshZeitRaumInHeader(getShowZeitraumInHeader(navOpt));
  } catch (ex) {
    console.error("error in pushSite " + site, ex);
  }
}

export function getSiteData() {
  var instance = getCurrentInstance();
  if (instance?.props.siteData) return instance?.props.siteData; // wenn die komponente direkt was bekommen hat dann von da :)
  if ((instance as any)?.setupContext?.attrs?.siteData) return (instance as any)?.setupContext?.attrs?.siteData;

  var dialogSiteData = getDialogSiteData();
  if (dialogSiteData) return dialogSiteData;

  const route = useRoute();

  if (route?.query?.id) {
    const id = route.query.id;
    if (typeof id == "string") {
      const json = localStorage.getItem(id);
      if (json) {
        return JSON.parse(json);
      }
    }
  }
  if (contentStack.length > 0)
    return contentStack[contentStack.length - 1].data;
  return route?.query;
}

export async function onShowSite(parameter: NavStackEntryRequest) {
  // if (parameter.replaceCurrent) {
  //   if (contentStack.length > 1)
  //     await goBack();
  // }
  await pushSite(
    parameter.site as string,
    parameter.data,
    parameter.title,
    parameter.aic,
    parameter.showZeitraumHeader,
    parameter.callOnLeave
  );
  // nextTick(() =>
  // );
}


export async function showSite(site: string, data: any, title: string, aic?: number, showZeitraum?: boolean) {
  await pushSite(site, data, title, aic, showZeitraum);
  return window;
}
export async function goBackTo(item: any, i: number = 0) {
  isNavigating = true;
  // for (let x = contentStack.length - 1; x >= 0; x--) {
  //   if (contentStack[x].site !== item.site) {
  //     UI.setActiveViewIndex(x);
  //     const currentPage = contentStack.pop();
  //     if (currentPage?.callOnLeave) {
  //       currentPage.callOnLeave();
  //     }
  //     if (window.history.length > 0)
  //       router.back();

  //     await router.isReady();
  //     //window.history.back();
  //   } else {
  //     break;
  //   }
  // }
  // UI.refreshZeitRaumInHeader();
  isNavigating = false;
}

export function refreshFullPageContent() {
  UI.refreshFullPageContent();
}
export function registerBackCallback(callback: () => boolean) {
  if (backCallbacks.indexOf(callback) < 0) {
    backCallbacks.push(callback);
  }
}
// für Back aus Dialog im Schedule zB notwendig!
export function unregisterBackCallback(callback: () => boolean) {
  const idx = backCallbacks.indexOf(callback);
  if (idx >= 0) {
    backCallbacks.splice(idx, 1);
  }
}

export async function goBack() {
  let isHandled = false;
  backCallbacks.forEach(cb => {
    if (!isHandled && cb()) {
      // If the callback returns true, we can stop the back navigation
      isHandled = isHandled || true;
    }
  });

  if (isHandled) {
    return;
  }

  isNavigating = true;

  if (closeHighestDialog(true, undefined)) {
    return;
  }


  if (contentStack.length > 1) {
    UI.setActiveViewIndex(Math.max(0, contentStack.length - 2));
    const currentPage = contentStack.pop();
    if (currentPage?.callOnLeave) {
      currentPage.callOnLeave();
    }
    UI.refreshZeitRaumInHeader(getShowZeitraumInHeader(contentStack[contentStack.length - 1]));
  }
  if (window.history.length > 0) {
    router.back();
    await router.isReady();
  }

  isNavigating = false;

  // UI.refreshZeitRaumInHeader();
}

export function goToState(location: string, state: any) {
  if (isNavigating) {
    return;
  }
  // hier is der state aber die page die wir ansurfen...
  console.log(
    "window changed to " + location + " state " + JSON.stringify(state)
  );
  if (state && state.site) {
    for (let i = contentStack.length - 1; i >= 0; i--) {
      if (UI.getActiveViewIndex() === 0) { break; }
      if (contentStack[i].site !== state.site) {
        UI.setActiveViewIndex(i - 1);
        contentStack.pop();
      } else {
        // wir sind fertig ;)
        break;
      }
    }
  }
  if (contentStack.length <= 0) {
    // wird ausserhalb der Webapplikation gehüpft - bleibt er im ROOT!
    // if (confirm("Es wurde keine Seite gefunden! wollen Sie sich abmelden?")) {
    //   handleLogout();
    // } else {
    setBottomActiveButton(0);
    isNavigating = true;
    contentStack.push(rootView);
    UI.setActiveViewIndex(contentStack.length - 1);
    router.push({
      name: rootView.site,
    }
    );
    isNavigating = false;
    // }
  }
  // UI.refreshZeitRaumInHeader();
}

function setBottomActiveButton(btn: number) {
  if (activeBtn !== btn) {
    activeBtn = btn;
    UI.setBottomActiveButton(btn);
  }
}

